import { render, staticRenderFns } from "./FlowMailingFrom.vue?vue&type=template&id=4c93646a&"
import script from "./FlowMailingFrom.vue?vue&type=script&lang=ts&"
export * from "./FlowMailingFrom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports